import TYPES from '../../types';

// Domain
import {
  ContactPointSowosModerateRepository,
} from '@/modules/flagship/contact-points/sowos-moderate/domain/repositories/contact-point-sowos-moderate-repository';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class GetModerateInformationByEmailQuery
  extends Query<Promise<void>> {
  @Inject(TYPES.CONTACT_POINT_SOWOS_MODERATE_REPOSITORY)
  private readonly repository!: ContactPointSowosModerateRepository;

  internalExecute(investment_product_fund_type_id: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.repository.getModerateInformation(investment_product_fund_type_id)
        .then(() => {
          resolve();
        })
        .catch(reject);
    });
  }
}
